import { Action } from "@reduxjs/toolkit";
import { IXetChungChiRequest } from "../../../model/request/xet-chung-chi/IXetChungChiRequest";
import { eChungChiSinhVienActionIds, IChungChiSinhVienActionTypes } from "../../action-types/xet-chung-chi/IChungChiSinhVienActions";
import { chungChiSinhVienApi } from "../../../api/xet-chung-chi/chungChiSinhVienApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { IChungChiSinhVienUpdateQuyetDinhRequest } from "../../../model/request/xet-chung-chi/IChungChiSinhVienUpdateQuyetDinhRequest";
import { IChungChiGenerateSoHieuRequest } from "../../../model/request/xet-chung-chi/IChungChiGenerateSoHieuRequest";
import { IChungChiGenerateSoVaoSoRequest } from "../../../model/request/xet-chung-chi/IChungChiGenerateSoVaoSoRequest";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { ITongHopChungChiLopRequest } from "../../../model/request/xet-chung-chi/ITongHopChungChiLopRequest";
const mainActions = rootActions.xetChungChi.chungChiSinhVien;

export function* chungChiSinhVienSaga(): any {
    yield takeLatest(eChungChiSinhVienActionIds.LOAD_BY_DOT_XET_START, loadByDotXetWoker);
    yield takeLatest(eChungChiSinhVienActionIds.LOAD_KHONG_DAT_BY_DOT_XET_START, loadKhongDatByDotXetWoker);
    yield takeEvery(eChungChiSinhVienActionIds.XET_START, xetWorker);
    yield takeEvery(eChungChiSinhVienActionIds.UPDATE_QUYET_DINH_START, updateQuyetDinhWorker);
    yield takeEvery(eChungChiSinhVienActionIds.UPDATE_SO_HIEU_START, updateSoHieuWorker);
    yield takeEvery(eChungChiSinhVienActionIds.UPDATE_SO_VAO_SO_START, updateSoVaoSoWorker);
    yield takeEvery(eChungChiSinhVienActionIds.SELECT_TONG_HOP_BY_LOP_START, selectTongHopLopHanhChinhWorker);
}

function* xetWorker(action: IChungChiSinhVienActionTypes) : any {
    const request = action.payload as IXetChungChiRequest;
    var response: IBaseResponse = yield chungChiSinhVienApi.Xet(request);
    if (response.is_success) {
        yield put(rootActions.xetChungChi.chungChiSinhVien.XET_SUCCESS(undefined));
    } else {
        yield put(rootActions.xetChungChi.chungChiSinhVien.XET_ERROR(response.message ?? "Không thể thực hiện xét"));
    }
}

function* loadByDotXetWoker(action: IChungChiSinhVienActionTypes) : any {
    const id_dot_xet = action.payload as number;
    const response: IBaseResponse = yield chungChiSinhVienApi.SelectDatByDotXet(id_dot_xet);
    if (response.is_success) {
        yield put(mainActions.LOAD_BY_DOT_XET_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(mainActions.LOAD_BY_DOT_XET_ERROR(response.message ?? "Không thể tải danh sách sinh viên đã đạt"));
    }
}

function* loadKhongDatByDotXetWoker(action: IChungChiSinhVienActionTypes) : any {
    const id_dot_xet = action.payload as number;
    const response: IBaseResponse = yield chungChiSinhVienApi.SelectKhongDatByDotXet(id_dot_xet);
    if (response.is_success) {
        yield put(mainActions.LOAD_KHONG_DAT_BY_DOT_XET_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(mainActions.LOAD_KHONG_DAT_BY_DOT_XET_ERROR(response.message ?? "Không thể tải danh sách sinh viên không đạt"));
    }
}

function* updateQuyetDinhWorker(action: IChungChiSinhVienActionTypes) : any {
    const request = action.payload as IChungChiSinhVienUpdateQuyetDinhRequest;
    const response: IBaseResponse = yield chungChiSinhVienApi.UpdateQuyetDinh(request);
    if (response.is_success) {
        yield put(mainActions.UPDATE_QUYET_DINH_SUCCESS(response.data));
    } else {
        yield put(mainActions.UPDATE_QUYET_DINH_ERROR(response.message ?? "Có lỗi khi cập nhật quyết định"));
    }
}

function* updateSoHieuWorker(action: IChungChiSinhVienActionTypes) : any {
    const request = action.payload as IChungChiGenerateSoHieuRequest;
    const response: IBaseResponse = yield chungChiSinhVienApi.UpdateSoHieu(request);
    if (response.is_success) {
        yield put(mainActions.UPDATE_SO_HIEU_SUCCESS(response.data));
    } else {
        yield put(mainActions.UPDATE_SO_HIEU_ERROR(response.message ?? "Có lỗi khi cập nhật số hiệu"));
    }
}
function* updateSoVaoSoWorker(action: IChungChiSinhVienActionTypes) : any {
    const request = action.payload as IChungChiGenerateSoVaoSoRequest;
    const response: IBaseResponse = yield chungChiSinhVienApi.UpdateSoVaoSo(request);
    if (response.is_success) {
        yield put(mainActions.UPDATE_SO_VAO_SO_SUCCESS(response.data));
    } else {
        yield put(mainActions.UPDATE_SO_VAO_SO_ERROR(response.message ?? "Có lỗi khi cập nhật số vào sổ"));
    }
}

function* selectTongHopLopHanhChinhWorker(action: IChungChiSinhVienActionTypes): any {
    const request = action.payload as ITongHopChungChiLopRequest;
    const response: IBaseResponse = yield chungChiSinhVienApi.SelectTongHopLopHanhChinh(request);
    if (response.is_success) {
        yield put(mainActions.SELECT_TONG_HOP_BY_LOP_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(mainActions.SELECT_TONG_HOP_BY_LOP_ERROR(response.message ?? "Không thể tải tổng hợp lớp hành chính"));
    }
}